export default [
  "yash.com",
  "rte.se",
  "softronic.se",
  "tritech.se",
  "delaval.cloud",
  "sii.pl",
  "lattec.com",
  "br-automation.com",
];
